import {
  GET_SAMSARA_GPS_REQUEST,
  GET_SAMSARA_GPS_SUCCESS,
  GET_SAMSARA_GPS_FAILURE,
  GET_SAMSARA_TRUCKS_REQUEST,
  GET_SAMSARA_TRUCKS_SUCCESS,
  GET_SAMSARA_TRUCKS_FAILURE,
  SET_SAMSARA_FILTER,
  CLEAR_SAMSARA_STATE
} from 'actions/samsaraActions';

const initialState = {
  gpsData: [],
  trucks: [], 
  isLoadingGps: false,
  isLoadingTrucks: false, 
  gpsError: null,
  truckError: null, 
  filter: {}
};

const samsaraReducer = (state = initialState, action) => {
  console.log('🔍 Reducer called:', action.type, action.payload);

  switch (action.type) {
    case GET_SAMSARA_GPS_REQUEST:
      return {
        ...state,
        isLoadingGps: true,
        gpsError: null
      };

    case GET_SAMSARA_GPS_SUCCESS:
      return {
        ...state,
        isLoadingGps: false,
        gpsData: action.payload || [],
        gpsError: null
      };

    case GET_SAMSARA_GPS_FAILURE:
      return {
        ...state,
        isLoadingGps: false,
        gpsError: action.payload,
        gpsData: []
      };

    case GET_SAMSARA_TRUCKS_REQUEST:
      return {
        ...state,
        isLoadingTrucks: true,
        truckError: null
      };

    case GET_SAMSARA_TRUCKS_SUCCESS:
      return {
        ...state,
        isLoadingTrucks: false,
        trucks: action.payload || [],
        truckError: null
      };

    case GET_SAMSARA_TRUCKS_FAILURE:
      return {
        ...state,
        isLoadingTrucks: false,
        trucks: [],
        truckError: action.payload
      };

    case SET_SAMSARA_FILTER:
      return {
        ...state,
        filter: { ...state.filter, ...action.payload }
      };

    case CLEAR_SAMSARA_STATE:
      return initialState;

    default:
      return state;
  }
};

export default samsaraReducer;
